export const TERTIARY = {
  DARKEST: '#1E2423',
  DARKER: '#3B4745',
  DARK: '#7A8A87',
  DEFAULT: '#F0F5F4',
  LIGHT: '#F0F5F4',
  LIGHTER: '#F0F5F4',
  LIGHTEST: '#F0F5F4',
} as const;
